import React, { memo } from 'react'
import './Home.sass'

const Home = () => {
  return <div>Home</div>
}

export default memo(Home)
